import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import useWindowWidth from '../../hooks/useWindowWidth';
import './Dashboard.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const COLORS_BG = [
    'rgba(16, 185, 129, 0.75)',
    'rgba(5, 150, 105, 0.75)',
    'rgba(52, 211, 153, 0.75)',
    'rgba(110, 231, 183, 0.75)',
    'rgba(167, 243, 208, 0.75)',
];
const COLORS_BORDER = [
    'rgba(16, 185, 129, 1)',
    'rgba(5, 150, 105, 1)',
    'rgba(52, 211, 153, 1)',
    'rgba(110, 231, 183, 1)',
    'rgba(167, 243, 208, 1)',
];

function RevenuesByCategoryChart({ data }) {
    const width = useWindowWidth();
    const isMobile = width < 768;

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: isMobile ? 'bottom' : 'right',
                labels: {
                    boxWidth: isMobile ? 12 : 16,
                    padding: isMobile ? 8 : 12,
                    font: { size: isMobile ? 11 : 12 },
                },
            },
            title: { display: !isMobile, text: 'Top 5 Receitas por Categoria' },
        },
    };

    const chartData = {
        labels: data?.map(d => d.category_name) || [],
        datasets: [{
            label: 'Receitas',
            data: data?.map(d => d.total) || [],
            backgroundColor: COLORS_BG,
            borderColor: COLORS_BORDER,
            borderWidth: 1,
        }],
    };

    const isEmpty = !data || data.length === 0;

    if (isMobile) {
        return (
            <div className="dash-chart-section-m">
                <p className="dash-chart-title-m">Top 5 Receitas por Categoria</p>
                <div style={{ height: '280px' }}>
                    {isEmpty
                        ? <p style={{ fontSize: '0.8rem', color: '#94a3b8', textAlign: 'center', paddingTop: '2rem' }}>Sem dados</p>
                        : <Doughnut options={options} data={chartData} />}
                </div>
            </div>
        );
    }

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body" style={{ height: '400px' }}>
                {isEmpty
                    ? <p className="text-muted text-center pt-5">Sem receitas por categoria no período.</p>
                    : <Doughnut options={options} data={chartData} />}
            </div>
        </div>
    );
}

export default RevenuesByCategoryChart;
